import { render, staticRenderFns } from "./AssignToCategory.vue?vue&type=template&id=14645d7a&scoped=true"
import script from "./AssignToCategory.vue?vue&type=script&lang=js"
export * from "./AssignToCategory.vue?vue&type=script&lang=js"
import style0 from "./AssignToCategory.vue?vue&type=style&index=0&id=14645d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14645d7a",
  null
  
)

export default component.exports